<script setup lang="ts">
import CupraHeading from '@/components/cupra/heading/CupraHeading.vue'
import PadelInnerView from './PadelInnerView.vue'

defineProps<{ framed: boolean; token?: string }>()
</script>

<template>
    <div
        v-if="framed"
        class="container mx-auto mt-6 px-4"
    >
        <CupraHeading
            as="h1"
            :variant="1"
        >
            Claim jouw speeltijd
        </CupraHeading>
        <div class="mt-4">
            <PadelInnerView :token="token" />
        </div>
    </div>
    <div
        v-else
        class="items z-10 flex flex-col xl:h-screen xl:flex-row xl:overflow-hidden"
    >
        <div class="h-[150px] w-full bg-[url(../img/bg_padel.webp)] bg-cover bg-center xl:h-full xl:w-2/5" />
        <div class="px-6 py-12 text-white xl:w-3/5 xl:overflow-y-scroll">
            <CupraHeading
                as="h1"
                :variant="1"
            >
                CUPRA x Padel
            </CupraHeading>
            <div class="container mx-auto mt-4">
                <PadelInnerView :token="token" />
            </div>
        </div>
    </div>
</template>
